import styled from 'styled-components';

import { LineupActionButton } from 'components/lineup/LineupActionButton';

export const Cta = styled(LineupActionButton)`
  display: flex;
  flex-direction: column;
  width: calc(12 * var(--unit));
  min-height: calc(5 * var(--unit));
  height: auto;
  color: var(--c-static-neutral-100);
  background: var(--c-brand-600);
  border-radius: calc(2.5 * var(--unit));
  border: unset;
  padding: 0 var(--double-unit);
  margin: var(--intermediate-unit) 0;
  &:hover {
    color: var(--c-static-neutral-100);
  }
  &:disabled {
    color: var(--c-neutral-700);
    background: var(--c-neutral-400);
    cursor: auto;
  }
`;
